import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "gatsby";
import {
  dispatchCurrentPage,
  nextPage,
} from "../../../redux/actions/paginationActions.js";
import Tooltip from "react-tooltip-lite";

const Pagination = ({ data, pageContext }) => {
  const dispatch = useDispatch();

  const pagesState = Array.from({ length: pageContext.pageCount }).map(
    (i, index) => index + 1
  );

  const currentPageState = pageContext.currentPage;

  const scroolPageState = useSelector(
    (state) => state.categoryReducer.scroolPage,
    shallowEqual
  );

  const cidState = data.cid;

  const loadingState = useSelector(
    (state) => state.categoryReducer.loading,
    shallowEqual
  );

  const renderFirstAndLastButtons = (
    <React.Fragment>
      <Link to={"/" + data.url + "/"}>
        <Tooltip content="First">
          <li className="first">
            <span class="material-icons">first_page</span>
          </li>
        </Tooltip>
      </Link>
      <Link
        to={
          currentPageState > 2
            ? "/" + data.url + "/" + (currentPageState - 1)
            : "/" + data.url + "/"
        }
      >
        <Tooltip content="Prev">
          <li className="prev">
            <span class="material-icons">navigate_before</span>
          </li>
        </Tooltip>
      </Link>
    </React.Fragment>
  );

  const handleNextPage = (page) => {
    if (scroolPageState < pagesState.length || page != 0) {
      dispatch(dispatchCurrentPage(page));
      dispatch(nextPage(page, cidState, false));
    } else {
      console.error("End of the page");
    }
  };

  return (
    <React.Fragment>
      {!loadingState && pagesState.length > 1 ? (
        <div
          style={{ margin: "40px 0px", textAlign: "center", width: "100%" }}
          className="pagination-container"
        >
          <ul id="pagination" className="pagination">
            {currentPageState > 1 ? renderFirstAndLastButtons : null}

            {pagesState.map((page) => {
              if (
                page <= currentPageState + 5 &&
                page >= currentPageState - 5
              ) {
                return (
                  <li
                    key={page}
                    className={currentPageState == page ? "selected" : ""}
                    style={
                      currentPageState == 1 && page == 1
                        ? { borderLeft: "unset" }
                        : null
                    }
                  >
                    <Link
                      key={page}
                      to={
                        page !== 1
                          ? "/" + data.url + "/" + page
                          : "/" + data.url + "/"
                      }
                    >
                      <Tooltip content={`Page Number ${page}`}>{page}</Tooltip>
                    </Link>
                  </li>
                );
              }
            })}

            {currentPageState == pagesState[pagesState.length - 1] ? null : (
              <React.Fragment>
                <li className="next">
                  <Link to={"/" + data.url + "/" + (currentPageState + 1)}>
                    <Tooltip content="Next">
                      <span className="material-icons">navigate_next</span>
                    </Tooltip>
                  </Link>
                </li>

                <li className="last">
                  <Link to={"/" + data.url + "/" + pageContext.pageCount}>
                    <Tooltip content="Last">
                      <span className="material-icons">last_page</span>
                    </Tooltip>
                  </Link>
                </li>
              </React.Fragment>
            )}
          </ul>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Pagination;
